export default __webpack_public_path__ + "static/media/aurelie-nguyen.c61b1ead.jpg";